import correction from '../assets/img/car/paint-correction.jpg';
import correction2 from '../assets/img/car/paint-correction2.jpg';
import ceramic from '../assets/img/car/ceramic-coating.jpg';
import ceramic2 from '../assets/img/car/ceramic-coating2.jpg';
import fulldetail from '../assets/img/car/full-detailing.jpg';
import fulldetail2 from '../assets/img/car/full-detailing2.jpg';
import interior from '../assets/img/car/interior-detailing.jpg';
import interior2 from '../assets/img/car/interior-detailing2.jpg';
import paintCorrection from '../assets/img/car/paint-correction.mp4'


export const carServices = [
  {
    id: "paint-correction",
    name: "Paint correction",
    images: [],
    src: paintCorrection
  },
  {
    id: "car-ceramic-coating",
    name: "Ceramic coating",
    images: [ceramic,ceramic2]
  },
  {
    id: "interior-detailing",
    name: "Interior detailing",
    images: [interior, interior2]
  },
  {
    id: "car-weekly-wash",
    name: "Weekly wash",
    images: [fulldetail, fulldetail2]
  },
];
